import { render } from "./ClienteDetalle.vue?vue&type=template&id=44b0f308"
import script from "./ClienteDetalle.vue?vue&type=script&lang=js"
export * from "./ClienteDetalle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__